import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';

export default function PartnerPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-white">
      <Navbar />

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-purple-600 to-purple-700 text-white relative overflow-hidden"
               style={{
                 backgroundImage: `url('https://readdy.ai/api/search-image?query=professional%20service%20worker%20smiling%20while%20using%20smartphone%20app%2C%20modern%20workspace%20background%2C%20purple%20and%20white%20theme%2C%20confident%20service%20professional%20with%20tools%2C%20success%20and%20earnings%20concept%2C%20clean%20professional%20photography&width=1200&height=600&seq=partner-hero&orientation=landscape')`,
                 backgroundSize: 'cover',
                 backgroundPosition: 'center'
               }}>
        <div className="absolute inset-0 bg-purple-600/80"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">
              Looking to grow your income?
            </h1>
            <p className="text-xl mb-8">
              Join BNM as a Service Partner and earn ₹25,000–₹50,000/month
            </p>
            
            <Link to="/apply" className="bg-white text-purple-600 px-8 py-4 rounded-full font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap text-lg">
              Apply Now
            </Link>
          </div>
        </div>
      </section>

      {/* Why Join Section */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Why Join BNM?</h2>
            <p className="text-xl text-gray-600">Benefits that make a difference</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-100 text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-time-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Work Flexibly</h3>
              <p className="text-gray-600">
                Set your own schedule and work when it suits you best
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-100 text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-money-rupee-circle-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Weekly Payouts</h3>
              <p className="text-gray-600">
                Receive your earnings directly in your account every week
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-100 text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-gift-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Zero Commission</h3>
              <p className="text-gray-600">
                No commission for your first 10 orders - keep 100% earnings
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How to Join Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">How to Join</h2>
            <p className="text-xl text-gray-600">Simple 5-step process to get started</p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="space-y-8">
              {[
                {
                  step: 1,
                  title: 'Walk in to our office',
                  desc: 'Visit our Nagpur office for initial registration',
                  icon: 'ri-building-line'
                },
                {
                  step: 2,
                  title: 'Fill out registration form',
                  desc: 'Complete the partner application with your details',
                  icon: 'ri-file-edit-line'
                },
                {
                  step: 3,
                  title: 'Provide KYC documents',
                  desc: 'Submit Aadhaar, PAN, and Bank account details',
                  icon: 'ri-file-list-3-line'
                },
                {
                  step: 4,
                  title: 'Download Partner App',
                  desc: "We'll help you install and train you on the app",
                  icon: 'ri-smartphone-line'
                },
                {
                  step: 5,
                  title: 'Start accepting jobs',
                  desc: 'Begin earning from Day One with immediate job access',
                  icon: 'ri-check-line'
                }
              ].map((item, index) => (
                <div key={index} className="flex items-start space-x-6">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center">
                      <i className={`${item.icon} text-2xl text-purple-600`}></i>
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center mb-2">
                      <div className="w-8 h-8 bg-purple-600 text-white rounded-full flex items-center justify-center mr-4 text-sm font-bold">
                        {item.step}
                      </div>
                      <h3 className="text-xl font-semibold text-gray-800">{item.title}</h3>
                    </div>
                    <p className="text-gray-600 ml-12">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Earnings Section */}
      <section className="py-16 bg-purple-50" id="earnings">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Earning Potential</h2>
            <p className="text-xl text-gray-600 mb-12">See how much you can earn based on services completed</p>
            
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl p-8 shadow-sm">
                <h3 className="text-2xl font-bold text-purple-600 mb-2">₹25,000</h3>
                <p className="text-gray-600 mb-4">Part-time (15-20 hrs/week)</p>
                <ul className="text-sm text-gray-500 space-y-1">
                  <li>• 3-4 services per day</li>
                  <li>• Flexible timing</li>
                  <li>• Weekend availability</li>
                </ul>
              </div>

              <div className="bg-purple-600 text-white rounded-xl p-8 shadow-lg transform scale-105">
                <h3 className="text-2xl font-bold mb-2">₹40,000</h3>
                <p className="text-purple-100 mb-4">Full-time (35-40 hrs/week)</p>
                <ul className="text-sm text-purple-100 space-y-1">
                  <li>• 6-8 services per day</li>
                  <li>• Peak hour bonuses</li>
                  <li>• Priority job allocation</li>
                </ul>
              </div>

              <div className="bg-white rounded-xl p-8 shadow-sm">
                <h3 className="text-2xl font-bold text-green-600 mb-2">₹50,000+</h3>
                <p className="text-gray-600 mb-4">Expert Level (40+ hrs/week)</p>
                <ul className="text-sm text-gray-500 space-y-1">
                  <li>• 10+ services per day</li>
                  <li>• Premium service rates</li>
                  <li>• Referral bonuses</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Partner Testimonials */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Partner Testimonials</h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="bg-purple-50 rounded-xl p-8">
              <div className="flex items-center mb-4">
                <div className="flex text-yellow-500">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
              </div>
              <p className="text-gray-700 mb-4">
                "I doubled my earnings while working flexible hours. BNM has changed my life completely!"
              </p>
              <p className="font-semibold text-gray-800">– Ramesh, Electrician</p>
            </div>

            <div className="bg-purple-50 rounded-xl p-8">
              <div className="flex items-center mb-4">
                <div className="flex text-yellow-500">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
              </div>
              <p className="text-gray-700 mb-4">
                "Weekly payouts make my life stress-free. I can plan my expenses better now."
              </p>
              <p className="font-semibold text-gray-800">– Sunita, House Cleaner</p>
            </div>
          </div>
        </div>
      </section>

      {/* App Download Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Download Partner App</h2>
            <p className="text-xl text-gray-600 mb-12">Accept jobs & earn on the go - Available on Android & iOS</p>
            
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <img src="https://bnm-content.s3.ap-south-1.amazonaws.com/images/partnerapp.webp" 
                     alt="Partner App Screenshots" 
                     className="rounded-2xl shadow-lg mx-auto object-top" />
              </div>
              
              <div className="text-left">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">Partner App Features:</h3>
                <ul className="space-y-4">
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-3 text-xl"></i>
                    <span className="text-gray-700">Accept/decline job requests</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-3 text-xl"></i>
                    <span className="text-gray-700">Real-time earnings tracking</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-3 text-xl"></i>
                    <span className="text-gray-700">Customer chat support</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-3 text-xl"></i>
                    <span className="text-gray-700">Weekly payout statements</span>
                  </li>
                </ul>
                
               <div className="mt-8 space-y-4">
  <div className="flex flex-col sm:flex-row gap-4">
    {/* Android Button */}
    <a
      href="https://play.google.com/store/apps/details?id=com.baainearme.partnerapp"
      target="_blank"
      rel="noopener noreferrer"
      className="bg-black text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center"
    >
      <i className="ri-google-play-fill mr-2 text-xl"></i>
      Download for Android
    </a>

    {/* iOS Button */}
    <a
      href="https://apps.apple.com/app/bnm-partner/id6751844889"
      target="_blank"
      rel="noopener noreferrer"
      className="bg-black text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center"
    >
      <i className="ri-app-store-fill mr-2 text-xl"></i>
      Download for iOS
    </a>
  </div>
</div>

              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Frequently Asked Questions</h2>
          </div>

          <div className="max-w-3xl mx-auto space-y-6">
            {[
              {
                q: 'What documents are required for registration?',
                a: 'You need Aadhaar card, PAN card, and bank account details for KYC verification.'
              },
              {
                q: 'How often do I receive payments?',
                a: 'Payments are processed weekly, directly transferred to your registered bank account.'
              },
              {
                q: 'How does the rating system work?',
                a: 'Customers rate your services from 1-5 stars. Higher ratings lead to more job opportunities and bonuses.'
              },
              {
                q: 'Can I work part-time?',
                a: 'Yes! You can set your availability and work as per your schedule - part-time or full-time.'
              }
            ].map((faq, index) => (
              <div key={index} className="bg-purple-50 rounded-xl p-6">
                <h3 className="text-lg font-semibold text-gray-800 mb-3">{faq.q}</h3>
                <p className="text-gray-600">{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-purple-600 text-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready to Begin?</h2>
          <p className="text-xl mb-12 max-w-2xl mx-auto">
            Join thousands of partners who are already earning with BNM
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/apply" className="bg-white text-purple-600 px-8 py-4 rounded-full font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
              Apply Now
            </Link>
            <button className="bg-purple-700 text-white px-8 py-4 rounded-full font-semibold hover:bg-purple-800 transition-colors cursor-pointer whitespace-nowrap border-2 border-purple-700">
              Call Support Team
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              {/* BNM logo (SVG) — scalable, color via currentColor */}
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 420 160"
  className="h-10 text-white"   // change to text-purple-600 etc.
  role="img"
  aria-label="BNM · Baainearme"
>
  <g fill="none" stroke="currentColor" strokeWidth="12" strokeLinecap="round">
    {/* Left ring */}
    <circle cx="50" cy="60" r="40" />
    {/* Vertical divider */}
    <line x1="110" y1="20" x2="110" y2="120" />
  </g>

  {/* Text block */}
  <g fill="currentColor">
    {/* BNM */}
    <text
      x="140"
      y="72"
      fontFamily="Poppins, Inter, Arial, sans-serif"
      fontWeight="800"
      fontSize="56"
    >
      BNM
    </text>

    {/* Baainearme */}
    <text
      x="140"
      y="120"
      fontFamily="Poppins, Inter, Arial, sans-serif"
      fontWeight="700"
      fontSize="32"
    >
      Baainearme
    </text>
  </g>
</svg>

              <p className="text-gray-400">
                Empowering service providers with flexible earning opportunities
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">For Partners</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/apply" className="hover:text-white cursor-pointer">Apply Now</Link></li>
                <li><Link to="/partner-support" className="hover:text-white cursor-pointer">Partner Support</Link></li>
                <li><Link to="/earnings-guide" className="hover:text-white cursor-pointer">Earnings Guide</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/customer" className="hover:text-white cursor-pointer">For Customers</Link></li>
                <li><Link to="/about" className="hover:text-white cursor-pointer">About Us</Link></li>
                <li><Link to="/faqs" className="hover:text-white cursor-pointer">FAQs</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Legal</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/partner-terms" className="hover:text-white cursor-pointer">Terms & Conditions</Link></li>
                <li><Link to="/partner-privacy" className="hover:text-white cursor-pointer">Privacy Policy</Link></li>
                <li><Link to="/refund-policy" className="hover:text-white cursor-pointer">Refund Policy</Link></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Baainearme. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
